import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import { Box } from '@mui/material';
//
import { varSmallClick, varMediumClick } from './variants';

const ButtonAnimate = ({ mediumClick = false, children, disabled = false, sx, ...other }) => {
  if (disabled) {
    return <Box sx={{ ...sx, display: 'inline-flex' }}>{children}</Box>;
  }

  return (
    <Box
      component={motion.div}
      whileTap="tap"
      whileHover="hover"
      variants={mediumClick ? varMediumClick : varSmallClick}
      sx={{ display: 'inline-flex', ...sx }}
      {...other}
    >
      {children}
    </Box>
  );
};

ButtonAnimate.propTypes = {
  mediumClick: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  sx: PropTypes.object
};

export default ButtonAnimate;
